<template>
    <div class="mt-3">
        <div v-if="newData.length===0 || newData===undefined">
                <div class="alert alert-secondary alert-dismissible fade show" role="alert">
                    {{$ml.get('NOT_EMAIL')}}!
                </div>
        </div>
        <div class="row m-0" v-for='(mail,index) in newData' :key="index">
            <div class="col-12 p-0 mb-2 border">
                <div class="input-group btn-click" slide-toggle>
                        <input class="form-control" v-model="mail.subject" disabled>
                        <div class="input-group-append" title="Mail Detayı Gör" @click="isdisplayfalse(index),mail.display=!mail.display">
                                <button class="btn btn-primary" type="button">
                                    <i class="f-18 fa fa-angle-down" v-if="mail.display"></i>
                                    <i class="f-18 fa fa-angle-up" v-if="!mail.display"></i>
                                </button>
                        </div>
                </div>
                <div v-show="!mail.display" class="mt-3 pr-3 pl-3" v-if="mail.from">
                    <div class="form-group row">
                        <label for="staticEmail" class="col-sm-2 col-form-label">FROM</label>
                        <div class="col-sm-10">
                            <input type="text" class="new-input" disabled v-model="mail.from">
                        </div>
                    </div>
                    <div class="form-group row" v-if="mail.to">
                        <label for="staticEmail" class="col-sm-2 col-form-label">TO</label>
                        <div class="col-sm-10">
                            <input type="text" class="new-input" disabled v-model="mail.to">
                        </div>
                    </div>
                    <div class="form-group row" v-if="mail.cc">
                        <label for="staticEmail" class="col-sm-2 col-form-label">CC</label>
                        <div class="col-sm-10">
                            <textarea class="new-textarea" disabled style="resize: none;">{{mail.cc}}</textarea>
                        </div>
                    </div>
                    <div class="form-group mb-3">
                            <label>{{$ml.get('MAIL_CONTENT')}}</label>
                            <textarea class="new-textarea" rows="10" disabled>{{mail.content}}</textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
    
<script>
    import axios from 'axios'
    import {mapState} from 'vuex'
    import {mapActions} from 'vuex'
    
    export default {
        name: 'showMailPanel',
        data() {
            return {
                subject:{},
                content:{},
                cc:{},
                from:{},
                to:{},
                newData:[],
                newobje:{}
            }
        },
        props: ["users", "orgId", "dealId", "contactId"],
        methods: {
            isdisplayfalse(index){
                for(let data in this.newData){
                    if(this.newData[index].display=='false'){
                        this.newData[data].display='false'
                    }
                }
            },
            getmail(){
                axios({
                    method:'POST',
                    url:'/getIncommingEmails',
                    baseURL: this.baseUrl,
                    data: {
                        orgId:this.orgId,
                        contactId:this.contactId,
                        dealId:this.dealId
                    },
                    withCredentials:true
                }).then((res)=>{
                    if(res.data.status.code==0){
                        this.newData=res.data.content.emails;
                    }else{
                        this.$notify({ 
                            group: 'foo',
                            type: 'error', 
                            title: 'Hata!',
                            text: res.data.status.desc 
                        })
                    }
                })
            },
            ...mapActions([
                'updateLoading'
            ]),
            
        },
        computed:{
            ...mapState([
                'organizationId',
                'baseUrl'
            ])
        },
        created(){
                
            this.getmail()
        }


    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .note p {
        padding: 0 !important;
        margin: 0 !important;
    }

   
</style>